"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Currencies = exports.Currency = void 0;
var Currency;
(function (Currency) {
    Currency["AUD"] = "AUD";
    Currency["BRL"] = "BRL";
    Currency["CAD"] = "CAD";
    Currency["CZK"] = "CZK";
    Currency["CLP"] = "CLP";
    Currency["DKK"] = "DKK";
    Currency["EUR"] = "EUR";
    Currency["HKD"] = "HKD";
    Currency["HUF"] = "HUF";
    Currency["JPY"] = "JPY";
    Currency["MYR"] = "MYR";
    Currency["MXN"] = "MXN";
    Currency["NOK"] = "NOK";
    Currency["NZD"] = "NZD";
    Currency["PHP"] = "PHP";
    Currency["PLN"] = "PLN";
    Currency["GBP"] = "GBP";
    Currency["SGD"] = "SGD";
    Currency["SEK"] = "SEK";
    Currency["CHF"] = "CHF";
    Currency["TWD"] = "TWD";
    Currency["THB"] = "THB";
    Currency["TRY"] = "TRY";
    Currency["USD"] = "USD";
    Currency["LKR"] = "LKR";
    Currency["KWD"] = "KWD";
    Currency["NIS"] = "NIS";
    Currency["JMD"] = "JMD";
    Currency["RON"] = "RON";
    Currency["ZAR"] = "ZAR";
    Currency["COP"] = "COP";
    Currency["ARS"] = "ARS";
    Currency["PEN"] = "PEN";
    Currency["UYU"] = "UYU";
    Currency["PAB"] = "PAB";
    Currency["CRC"] = "CRC";
})(Currency || (exports.Currency = Currency = {}));
exports.Currencies = (_a = {},
    _a[Currency.AUD] = {
        title: 'Australian Dollar',
        code: Currency.AUD,
        symbol: '$'
    },
    _a[Currency.BRL] = {
        title: 'Brazilian Real',
        code: Currency.BRL,
        symbol: '$'
    },
    _a[Currency.CAD] = {
        title: 'Canadian Dollar',
        code: Currency.CAD,
        symbol: '$'
    },
    _a[Currency.CZK] = {
        title: 'Czech Koruna',
        code: Currency.CZK,
        symbol: 'Kč'
    },
    _a[Currency.CLP] = {
        title: 'Chilean Peso',
        code: Currency.CLP,
        symbol: '$'
    },
    _a[Currency.DKK] = {
        title: 'Danish Krone',
        code: Currency.DKK,
        symbol: 'kr'
    },
    _a[Currency.EUR] = {
        title: 'Euro',
        code: Currency.EUR,
        symbol: '€'
    },
    _a[Currency.HKD] = {
        title: 'Hong Kong Dollar',
        code: Currency.HKD,
        symbol: '$'
    },
    _a[Currency.HUF] = {
        title: 'Hungarian Forint',
        code: Currency.HUF,
        symbol: 'Ft'
    },
    _a[Currency.JPY] = {
        title: 'Japanese Yen',
        code: Currency.JPY,
        symbol: '¥'
    },
    _a[Currency.MYR] = {
        title: 'Malaysian Ringgit',
        code: Currency.MYR,
        symbol: 'RM'
    },
    _a[Currency.MXN] = {
        title: 'Mexican Peso',
        code: Currency.MXN,
        symbol: '$'
    },
    _a[Currency.NOK] = {
        title: 'Norwegian Krone',
        code: Currency.NOK,
        symbol: 'kr'
    },
    _a[Currency.NZD] = {
        title: 'New Zealand Dollar',
        code: Currency.NZD,
        symbol: '$'
    },
    _a[Currency.PHP] = {
        title: 'Philippine Peso',
        code: Currency.PHP,
        symbol: '₱'
    },
    _a[Currency.PLN] = {
        title: 'Polish Zloty',
        code: Currency.PLN,
        symbol: 'zł'
    },
    _a[Currency.GBP] = {
        title: 'Pound Sterling',
        code: Currency.GBP,
        symbol: '£'
    },
    _a[Currency.SGD] = {
        title: 'Singapore Dollar',
        code: Currency.SGD,
        symbol: '$'
    },
    _a[Currency.SEK] = {
        title: 'Swedish Krona',
        code: Currency.SEK,
        symbol: 'kr'
    },
    _a[Currency.CHF] = {
        title: 'Swiss Franc',
        code: Currency.CHF,
        symbol: 'CHF'
    },
    _a[Currency.TWD] = {
        title: 'Taiwan New Dollar',
        code: Currency.TWD,
        symbol: '$'
    },
    _a[Currency.THB] = {
        title: 'Thai Baht',
        code: Currency.THB,
        symbol: '฿'
    },
    _a[Currency.TRY] = {
        title: 'Turkish Lira',
        code: Currency.TRY,
        symbol: '₺'
    },
    _a[Currency.USD] = {
        title: 'U.S. Dollar',
        code: Currency.USD,
        symbol: '$'
    },
    _a[Currency.LKR] = {
        title: 'Sri Lankan rupee',
        code: Currency.LKR,
        symbol: '₨'
    },
    _a[Currency.KWD] = {
        title: 'Kuwaiti Dinar',
        code: Currency.KWD,
        symbol: 'ك'
    },
    _a[Currency.NIS] = {
        title: 'New Israeli Shekel',
        code: Currency.NIS,
        symbol: '₪'
    },
    _a[Currency.JMD] = {
        title: 'Jamaican Dollar',
        code: Currency.JMD,
        symbol: 'J$'
    },
    _a[Currency.RON] = {
        title: 'Romanian Leu',
        code: Currency.RON,
        symbol: 'lei'
    },
    _a[Currency.ZAR] = {
        title: 'South African Rand',
        code: Currency.ZAR,
        symbol: 'R'
    },
    _a[Currency.COP] = {
        title: 'Colombian Peso',
        code: Currency.COP,
        symbol: '$'
    },
    _a[Currency.ARS] = {
        title: 'Argentine Peso',
        code: Currency.ARS,
        symbol: '$'
    },
    _a[Currency.PEN] = {
        title: 'Peruvian Sol',
        code: Currency.PEN,
        symbol: 'S/.'
    },
    _a[Currency.UYU] = {
        title: 'Uruguayan Peso',
        code: Currency.UYU,
        symbol: '$U'
    },
    _a[Currency.PAB] = {
        title: 'Panamanian Balboa',
        code: Currency.PAB,
        symbol: 'B/.'
    },
    _a[Currency.CRC] = {
        title: 'Costa Rican Colon',
        code: Currency.CRC,
        symbol: '₡'
    },
    _a);
//# sourceMappingURL=currency.js.map